import "../assets/styles/home.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import NavbarComponent from "../components/Navbar-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWifi,
  faCar,
  faMugHot,
  faSnowflake,
  faLeaf,
  faBath,
  faMapMarkerAlt,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation, Trans } from "react-i18next";

function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const amenities = [
    { icon: faWifi, key: "wifi" },
    { icon: faCar, key: "parking" },
    { icon: faMugHot, key: "breakfast" },
    { icon: faSnowflake, key: "aircon" },
    { icon: faLeaf, key: "garden" },
    { icon: faBath, key: "bathroom" },
  ];

  const reviews = [
    { name: "Maria T.", textKey: "home.reviews.r1", stars: 5 },
    { name: "Luca R.", textKey: "home.reviews.r2", stars: 5 },
    { name: "Sophie M.", textKey: "home.reviews.r3", stars: 5 },
  ];

  const galleryItems = [
    { img: "letto1", labelKey: "home.galleryPreview.rooms" },
    { img: "bagno1", labelKey: "home.galleryPreview.bathrooms" },
    { img: "cucina1", labelKey: "home.galleryPreview.kitchen" },
    { img: "salone1", labelKey: "home.galleryPreview.lounge" },
    { img: "fuori1", labelKey: "home.galleryPreview.outdoor" },
  ];

  return (
    <div className="home-page">
      {/* ── HERO ── */}
      <section className="hero-section">
        <div className="hero-overlay" />
        <div className="hero-nav-wrap">
          <NavbarComponent />
        </div>
        <div className="hero-content">
          <img
            src={require("../assets/images/il-parco.png")}
            className="hero-logo"
            alt="Il Parco Logo"
          />
          <h1 className="hero-title">{t('home.hero.title')}</h1>
          <p className="hero-tagline">{t('home.hero.tagline')}</p>
          <p className="hero-subtitle">
            {t('home.hero.subtitle')}
          </p>
          <div className="hero-buttons">
            <button className="btn-hero-primary" onClick={() => navigate("/gallery")}>
              {t('home.hero.btnPhotos')}
            </button>
            <button className="btn-hero-secondary" onClick={() => navigate("/contatti")}>
              {t('home.hero.btnBook')}
            </button>
          </div>
        </div>
        <div className="hero-scroll-hint">
          <span>{t('home.hero.scrollHint')}</span>
          <div className="scroll-line" />
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="about-section">
        <div className="about-inner">
          <div className="about-images">
            <img
              src={require("../assets/images/salone3.jpg")}
              alt="Bagno Il Parco"
              className="about-img-main"
            />
            <img
              src={require("../assets/images/bagno2.jpg")}
              alt="Salone Il Parco"
              className="about-img-secondary"
            />
          </div>
          <div className="about-text">
            <span className="section-eyebrow">{t('home.about.eyebrow')}</span>
            <h2 className="section-title">
              {t('home.about.title1')}<br />{t('home.about.title2')}
            </h2>
            <p dangerouslySetInnerHTML={{ __html: t('home.about.p1') }} />
            <p>
              {t('home.about.p2')}
            </p>
            <div className="about-stats">
              <div className="stat">
                <span className="stat-num">4</span>
                <span className="stat-lbl">{t('home.about.statRooms')}</span>
              </div>
              <div className="stat">
                <span className="stat-num">★ 4.9</span>
                <span className="stat-lbl">{t('home.about.statRating')}</span>
              </div>
              <div className="stat">
                <span className="stat-num">100%</span>
                <span className="stat-lbl">{t('home.about.statSatisfied')}</span>
              </div>
            </div>
            <button className="btn-outline" onClick={() => navigate("/contatti")}>
              {t('home.about.btnContact')}
            </button>
          </div>
        </div>
      </section>

      {/* ── AMENITIES ── */}
      <section className="amenities-section">
        <div className="section-header">
          <span className="section-eyebrow">{t('home.amenities.eyebrow')}</span>
          <h2 className="section-title">{t('home.amenities.title1')}<br />{t('home.amenities.title2')}</h2>
        </div>
        <div className="amenities-grid">
          {amenities.map((a, i) => (
            <div key={i} className="amenity-card">
              <div className="amenity-icon-wrap">
                <FontAwesomeIcon icon={a.icon} />
              </div>
              <h3>{t(`home.amenities.${a.key}.title`)}</h3>
              <p>{t(`home.amenities.${a.key}.desc`)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── GALLERY PREVIEW ── */}
      <section className="gallery-preview-section">
        <div className="gallery-preview-header">
          <span className="section-eyebrow light">{t('home.galleryPreview.eyebrow')}</span>
          <h2 className="section-title">{t('home.galleryPreview.title')}</h2>
          <p className="gallery-preview-subtitle">
            {t('home.galleryPreview.subtitle')}
          </p>
        </div>
        <div className="gallery-preview-grid">
          {galleryItems.map((item, i) => (
            <div
              key={i}
              className={`gallery-thumb${i === 0 ? " gallery-thumb--large" : ""}`}
              style={{
                backgroundImage: `url(${require(`../assets/images/${item.img}.jpg`)})`,
              }}
              onClick={() => navigate("/gallery")}
            >
              <div className="gallery-thumb-overlay">
                <span>{t(item.labelKey)}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="gallery-preview-cta">
          <button className="btn-gallery" onClick={() => navigate("/gallery")}>
            {t('home.galleryPreview.btnAll')}
          </button>
        </div>
      </section>

      {/* ── LOCATION ── */}
      <section className="location-section">
        <div className="location-inner">
          <div className="location-image-wrap">
            <img
              src={require("../assets/images/best-of-Puglia-Italy-transformed.jpeg")}
              alt="Puglia, Salento"
            />
          </div>
          <div className="location-content">
            <span className="section-eyebrow">{t('home.location.eyebrow')}</span>
            <h2 className="section-title">
              {t('home.location.title1')}<br />{t('home.location.title2')}
            </h2>
            <p dangerouslySetInnerHTML={{ __html: t('home.location.p1') }} />
            <ul className="location-list">
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <span>{t('home.location.loc1')}</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <span>{t('home.location.loc2')}</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <span>{t('home.location.loc3')}</span>
              </li>
            </ul>
            <button className="btn-solid" onClick={() => navigate("/contatti")}>
              {t('home.location.btn')}
            </button>
          </div>
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section className="reviews-section">
        <div className="section-header">
          <span className="section-eyebrow">{t('home.reviews.eyebrow')}</span>
          <h2 className="section-title">{t('home.reviews.title')}</h2>
        </div>
        <div className="reviews-grid">
          {reviews.map((r, i) => (
            <div key={i} className="review-card">
              <div className="review-stars">
                {[...Array(r.stars)].map((_, j) => (
                  <FontAwesomeIcon key={j} icon={faStar} />
                ))}
              </div>
              <p className="review-text">"{t(r.textKey)}"</p>
              <span className="review-author">— {r.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="cta-overlay" />
        <div className="cta-content">
          <h2>
            {t('home.cta.title1')}<br />{t('home.cta.title2')}
          </h2>
          <p>{t('home.cta.subtitle')}</p>
          <button className="btn-cta" onClick={() => navigate("/contatti")}>
            {t('home.cta.btn')}
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="site-footer">
        <img
          src={require("../assets/images/il-parco.png")}
          alt="Il Parco"
          className="footer-logo"
        />
        <p>{t('home.footer.copy')}</p>
        <div className="footer-nav">
          <span onClick={() => navigate("/")}>{t('home.footer.home')}</span>
          <span onClick={() => navigate("/gallery")}>{t('home.footer.galleria')}</span>
          <span onClick={() => navigate("/contatti")}>{t('home.footer.contatti')}</span>
        </div>
      </footer>
    </div>
  );
}

export default Home;
